export default (state: IKeyValue) => ({
	coachMarksSeen: state.coachMarksSeen || [],
	foo: state.foo,
});
